/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';

type LogoProps = {
  logoUrl: string | undefined;
  isExpanded?: boolean;
};

export default function Logo({ logoUrl, isExpanded }: LogoProps) {
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const handleImageLoad = () => {
      const imageElement = imageRef.current;
      if (imageElement && imageElement.naturalWidth && imageElement.naturalHeight) {
        const aspectRatio = imageElement.naturalWidth / imageElement.naturalHeight;
        if (Math.abs(aspectRatio) < 1.2) {
          imageElement.style.width = '65px';
          imageElement.style.height = 'auto';
        } else if (Math.abs(aspectRatio) >= 1.2 && Math.abs(aspectRatio) < 2) {
          imageElement.style.width = '105px';
          imageElement.style.height = 'auto';
        } else {
          imageElement.style.width = '130px';
          imageElement.style.height = 'auto';
        }
      }
    };
    const imageElement = imageRef.current;
    if (imageElement && imageElement.complete) {
      handleImageLoad();
    } else if (imageElement) {
      imageElement.addEventListener('load', handleImageLoad);
    }
    return () => {
      if (imageElement) {
        imageElement.removeEventListener('load', handleImageLoad);
      }
    };
  }, [imageRef?.current]);

  return <img src={logoUrl} alt="logo" ref={imageRef} style={{ maxWidth: isExpanded ? 130 : 50 }} />;
}
